<script>
    import { goto } from "$app/navigation";
    import { startWhirlpoolTransition } from "$lib/utils/whirlpoolTransition";

    function handleRuneClick(e) {
        e.preventDefault();
        const audio = new Audio("/sounds/whirlpool.mp3");
        audio.volume = 0.7;
        audio.play().catch(() => {});
        startWhirlpoolTransition(() => goto("/warrior-of-the-gods"));
    }
</script>

<footer id="footer" class="footer">
    <div class="container">
        <div class="footer-grid">
            <a
                class="footer-rune"
                href="/warrior-of-the-gods"
                aria-label="Hidden game"
                onclick={handleRuneClick}
            ><svg viewBox="0 0 35 32" aria-hidden="true" focusable="false"><use href="#icon-valknut"/></svg></a>
            <p class="copyright">
                &copy; <span id="year"></span> dinglandia.design
            </p>
            <nav class="social-nav">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://twitter.com/dinglestein"
                    aria-label="dinglandia on X"
                    ><div class="icon-new" name="x"></div></a
                >
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://codepen.io/dinglestein"
                    aria-label="dinglandia on CodePen"
                    ><div class="icon-new" name="codepen"></div></a
                >
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://github.com/dinglestein"
                    aria-label="dinglandia on GitHub"
                    ><div class="icon-new" name="github"></div></a
                >
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://soundcloud.com/dinglestein"
                    aria-label="dinglandia on SoundCloud"
                    ><div class="icon-new" name="soundcloud"></div></a
                >
            </nav>
        </div>
    </div>
</footer>

<style>
    .footer-rune {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 48px;
        /* Runestone arch shape — rounded top, flat-ish bottom */
        border-radius: 50% 50% 3px 3px / 28% 28% 3px 3px;
        /* Light: black stone / Dark: white stone */
        background: light-dark(
            linear-gradient(160deg, #2a2a2a 0%, #181818 55%, #0d0d0d 100%),
            linear-gradient(160deg, #f0ede8 0%, #ddd9d2 55%, #c8c3bb 100%)
        );
        box-shadow:
            inset 0 1px 0 light-dark(rgba(255,255,255,0.12), rgba(255,255,255,0.5)),
            inset 0 -2px 5px rgba(0, 0, 0, 0.4),
            0 2px 4px rgba(0, 0, 0, 0.4),
            0 4px 10px rgba(0, 0, 0, 0.25);
        text-decoration: none;
        cursor: pointer;
        opacity: 0.5;
        /* Light: white valknut on black stone / Dark: black valknut on white stone */
        color: light-dark(#fffff0, #1a1714);
        transition:
            opacity 0.35s ease,
            color 0.35s ease,
            filter 0.35s ease,
            box-shadow 0.35s ease,
            transform 0.35s ease;
    }

    .footer-rune svg {
        width: 18px;
        height: auto;
        display: block;
    }

    .footer-rune:hover {
        opacity: 1;
        transform: scale(1.08);
        /* Valknut lights up brand blue */
        color: #ffab00;
        filter:
            drop-shadow(0 0 3px rgba(255, 171, 0, 0.9))
            drop-shadow(0 0 8px rgba(255, 171, 0, 0.55))
            drop-shadow(0 0 18px rgba(255, 171, 0, 0.25));
        /* Stone gets a yellow glow */
        box-shadow:
            inset 0 1px 0 light-dark(rgba(255,255,255,0.12), rgba(255,255,255,0.5)),
            inset 0 -2px 5px rgba(0, 0, 0, 0.4),
            0 2px 4px rgba(0, 0, 0, 0.4),
            0 4px 10px rgba(0, 0, 0, 0.25),
            0 0 10px rgba(255, 171, 0, 0.35),
            0 0 24px rgba(255, 171, 0, 0.18),
            0 0 48px rgba(255, 171, 0, 0.08);
    }
</style>
